module.exports = __webpack_public_path__ + "static/media/MV-1.851f876e.png";